import React from 'react';
import { useSelector } from 'react-redux';
import GenericButton from './GenericButton';

/**
 * @param props.framesUrl
 */

const IncompatiblePrescription = props => {
    const labels = useSelector(state => state.main.labels);

    return (
        <div className="rx-incompatible-content">
            <div className="rx-incompatible-error">{labels.prescription.compatibleFrameError}</div>
            {props.framesUrl !== null && (
                <div className="compatible-frame-content">
                    {labels.prescription.compatibleFrameSubLabel}{' '}
                    <GenericButton
                        className="border-button redirect-button"
                        title={labels.prescription.compatibleFramesButton}
                        handleClick={() => {
                            if (
                                props.config &&
                                props.config.prescriptionModule &&
                                props.prescriptionObject
                            ) {
                                props.config.prescriptionModule.savePrescription(
                                    props.prescriptionObject
                                );
                            }

                            location.href = props.framesUrl;
                        }}
                    >
                        {labels.prescription.compatibleFramesButton}
                    </GenericButton>
                </div>
            )}
        </div>
    );
};
export default IncompatiblePrescription;
